import { useState } from "react";

import { PCRSCredentialsForm } from "components/HealthlinkCredentialsModal/PCRSCredentialsForm/PCRSCredentialsForm";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

export const PCRSCredentialsModal = ({
  buttonText,
  initialValues,
  isDisabled,
  buttonVariant = "primary",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant={buttonVariant}
        onClick={() => setIsModalOpen(true)}
        disabled={isDisabled}
      >
        {buttonText || "Configure PCRS credentials"}
      </Button>
      <Dialog
        title={buttonText || "Configure PCRS credentials"}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={600}
      >
        <PCRSCredentialsForm
          initialValues={initialValues}
          closeModal={() => setIsModalOpen(false)}
        />
      </Dialog>
    </>
  );
};
